import { z } from "zod";

export default z.object({ "month": z.number().int().describe("월 영업일 수"), "today": z.number().int().describe("오늘 까지 영업일 수") }).describe("회사 월별 캘린더 영업일");
